import "./styles.scss";

import React from "react";
import { Link } from "gatsby";
import clsx from "clsx";

const Heading = ({ title, subtitle, url }) => {
  if (!title) return null;

  return (
    <div className={clsx("heading", url && "heading--link")}>
      <div>
        <h2>{title}</h2>
        {subtitle && <h3>{subtitle}</h3>}
      </div>
      {url && (
        <Link to={url}>
          <img
            src={require("assets/icons/arrow-right--new.svg").default}
            alt=""
          />
        </Link>
      )}
    </div>
  );
};

export default Heading;
